import { createFileRoute } from "@tanstack/react-router";

import { InvitationPage } from "../../../features/staff/invitation-page";

export const Route = createFileRoute("/_app/invitations/$token")({ component: Invitation });

function Invitation() {
  const { token } = Route.useParams();
  return <InvitationPage token={token} />;
}
